export default __webpack_public_path__ + "static/c-other-1-a37656f525edbcb0440703e378008af4.png";